import React, { useContext } from 'react';
import { array, object } from 'prop-types';
import { AppContext } from '../AppContext';

import MapIcon from './MapIcon';

function Locations({ filtered }) {
  const { onClick, theme } = useContext(AppContext);

  function computeName(item) {
    if(!item && !item.value) {
      return "";
    }
    if(item.value === item.country) {
      return 'country_name';
    }
    if(item.value === item.state_name) {
      return 'state_name';
    }
    if(item.value === item.city) {
      return 'city';
    }
    const splitVal = item.value.split(',').map((item) => {
      return (item) ? item.trim() : "";
    });
    let keyString = '';
    splitVal.forEach((element, index) => {
      if(element) {
          if(index === 0 && element.trim() === item.city) {
            keyString += 'city-';
            return;
          }
          if(index === 1 & element.trim() === item.state_name ) {
            keyString += 'state_name-';
            return;
          }
          if(index === 2 && element.trim() === item.country) {
            keyString += 'country_name';
            return;
          }
      }else {
        console.log("Element is empty after spilt on index"+ index);
      }
    });
    return keyString;
  }

  const locations = filtered.map((item, index) => {
    if (!item.data) {
      // cities, states, and countries
      return (
        <button
          key={index}
          onClick={onClick}
          className="cell small-12 medium-6 large-4 find-a-hotel-suggestion suggestion offers-filter-suggestion"
          style={{ textAlign: 'left' }}
          data-filter-key={computeName(item)}
          data-value={item.value}
        >
          <MapIcon alt={theme.alt} src={theme.src} />
          <span>{item.value.replace(/,\s?,/g, ',')}</span>
        </button>
      );
    } else if (item.data) {
      // addresses associated with hotels
      return (
        <button
          key={index}
          onClick={onClick}
          className="cell small-12 medium-6 large-4 find-a-hotel-suggestion suggestion offers-filter-suggestion"
          style={{ textAlign: 'left' }}
          data-filter-key="city-state_name-country_name"
          data-value={item.data && item.data.location}
        >
          <MapIcon alt={theme.alt} src={theme.src} />
          <span>{item.data && item.data.location.replace(/,\s?,/g, ',')}</span>
        </button>
      );
    }
  });

  return locations;
}

Locations.propTypes = {
  filtered: array.isRequired,
  theme: object
};

export default Locations;
